module.exports = __webpack_public_path__ + "img/IMG_0328_L_WoodMatted_MockedUp.83218aa1.jpg";